import React from 'react';
import { useAppData } from '../AppContext';
import { DEF_HOME_VIDEOS } from '../store';
import './HomeVideos.css';

const getYouTubeEmbedUrl = (url) => {
  if (!url || typeof url !== 'string') return '';

  try {
    const parsed = new URL(url.trim());
    const host = parsed.hostname.replace('www.', '');
    let videoId = '';

    if (host === 'youtu.be') {
      videoId = parsed.pathname.slice(1).split('/')[0];
    } else if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (parsed.pathname === '/watch') {
        videoId = parsed.searchParams.get('v') || '';
      } else if (parsed.pathname.startsWith('/shorts/')) {
        videoId = parsed.pathname.replace('/shorts/', '').split('/')[0];
      } else if (parsed.pathname.startsWith('/embed/')) {
        videoId = parsed.pathname.replace('/embed/', '').split('/')[0];
      }
    }

    if (!videoId) return '';
    return `https://www.youtube.com/embed/${videoId}`;
  } catch {
    return '';
  }
};

const HomeVideos = () => {
  const { homeVideos } = useAppData();
  const videos = (homeVideos || DEF_HOME_VIDEOS).slice(0, 3);

  return (
    <section className="home-videos-section">
      <div className="home-videos-container">
        <h2 className="home-videos-title" data-aos="fade-up">Watch ZINGA In Action</h2>
        <p className="home-videos-subtitle" data-aos="fade-up" data-aos-delay="80">
          Product highlights, application demos, and real-world project videos
        </p>

        <div className="home-videos-grid">
          {videos.map((video, idx) => {
            const embedUrl = getYouTubeEmbedUrl(video?.url);
            return (
              <div key={video?.id || idx} className="home-video-card" data-aos="fade-up" data-aos-delay={idx * 80}>
                {embedUrl ? (
                  <div className="home-video-frame-wrap">
                    <iframe
                      className="home-video-frame"
                      src={embedUrl}
                      title={video?.title || `YouTube video ${idx + 1}`}
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    />
                  </div>
                ) : (
                  <div className="home-video-empty">Add a valid YouTube URL in Admin Home page</div>
                )}
                <h3 className="home-video-caption">{video?.title || `Video ${idx + 1}`}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeVideos;